import React from "react";

const SpeedItemPhoneLine = () => {
    return (
        <React.Fragment>            
            <ul className="extras mt-0">
                <li className="bold">Unlimited national & international business calls</li>
            </ul>
        </React.Fragment>
    );
};
export default SpeedItemPhoneLine;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/SpeedItemPhoneLine.js